'use strict';

import  _ from 'lodash-es';

var util = {
	filterArr: function (arr) {
		var finishedArr = new Array();

		arr.forEach(function (o) {
			if (typeof o === "object") {
				var finishedObj = new Object();

				Object.keys(o).forEach(function (k) {
					if (!o[k]) {
						return;
					}
					finishedObj[k] = o[k];
				});

				if (Object.keys(finishedObj).length > 0) {
					finishedArr.push(finishedObj);
				}
			} else if (!!o) {
				finishedArr.push(o);
			}
		});

		return finishedArr;
	},

	filterObj: function (o) {
		var finishedObj = {};

		Object.keys(o).forEach(function (k) {
			if (!o[k]) {
				return;
			} else if (o[k] instanceof Array) {
				finishedObj[k] = this.filterArr(o[k]);
			} else {
				finishedObj[k] = o[k];
			}
		}, this);

		return finishedObj;
	},

	/**
	 * @function
	 * @description appends the parameter with the given name and value to the given url and returns the changed url
	 * @param {String} url the url to which the parameter will be added
	 * @param {String} name the name of the parameter
	 * @param {String} value the value of the parameter
	 */
	appendParamToURL: function (url, name, value) {
		// quit if the param already exists
		if (url.indexOf(name + '=') !== -1) {
			return url;
		}
		var separator = url.indexOf('?') !== -1 ? '&' : '?';

		return url + separator + name + '=' + encodeURIComponent(value);
	},

	/**
	 * @function
	 * @description remove the parameter and its value from the given url and returns the changed url
	 * @param {String} url the url from which the parameter will be removed
	 * @param {String} name the name of parameter that will be removed from url
	 */
	removeParamFromURL: function (url, name) {
		if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
			return url;
		}
		var hash;
		var params;
		var domain = url.split('?')[0];
		var paramUrl = url.split('?')[1];
		var newParams = [];
		// if there is a hash at the end, store the hash
		if (paramUrl.indexOf('#') > -1) {
			hash = paramUrl.split('#')[1] || '';
			paramUrl = paramUrl.split('#')[0];
		}
		params = paramUrl.split('&');
		for (var i = 0; i < params.length; i++) {
			// put back param to newParams array if it is not the one to be removed
			if (params[i].split('=')[0] !== name) {
				newParams.push(params[i]);
			}
		}
		return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
	},

	/**
	 * @function
	 * @description appends the parameters to the given url and returns the changed url
	 * @param {String} url the url to which the parameters will be added
	 * @param {Object} params
	 */
	appendParamsToUrl: function (url, params) {
		var _url = url;
		_.each(params, function (value, name) {
			_url = this.appendParamToURL(_url, name, value);
		}.bind(this));

		return _url;
	},
	/**
	 * @function
	 * @description extract the query string from URL
	 * @param {String} url the url to extra query string from
	 **/
	getQueryString: function (url) {
		var qs;
		if (!_.isString(url)) {
			return;
		}
		var a = document.createElement('a');
		a.href = url;
		if (a.search) {
			qs = a.search.substr(1); // remove the leading ?
		}
		return qs;
	},

	updateQueryStringParam: function (url, paramName, newVal) {
		var _url = url;

		if (_url.indexOf(paramName) === -1) {
			return _url;
		}

		var newParamObj = new Object();
		newParamObj[paramName] = newVal;

		_url = this.removeParamFromURL(_url, paramName);
		_url = this.appendParamsToUrl(_url, newParamObj);

		return _url;
	},

	getHashParam: function (paramName) {
		var output = "";

		var hashParams = window.location.hash.replace("#", "").split("&");
		for (var i = 0; i < hashParams.length; i++) {
			if (hashParams[i].indexOf(paramName) > -1) {
				output = hashParams[i].split("=")[1];
			}
		}

		return output;
	},

	/**
	 * @function
	 * @description
	 * @param {String}
	 * @param {String}
	 */
	elementInViewport: function (el, offsetToTop) {
		var top = el.offsetTop,
			left = el.offsetLeft,
			width = el.offsetWidth,
			height = el.offsetHeight;

		while (el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}

		if (typeof (offsetToTop) !== 'undefined') {
			top -= offsetToTop;
		}

		if (window.pageXOffset !== null) {
			return (
				top < (window.pageYOffset + window.innerHeight) &&
				left < (window.pageXOffset + window.innerWidth) &&
				(top + height) > window.pageYOffset &&
				(left + width) > window.pageXOffset
			);
		}

		if (document.compatMode === 'CSS1Compat') {
			return (
				top < (window.document.documentElement.scrollTop + window.document.documentElement.clientHeight) &&
				left < (window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth) &&
				(top + height) > window.document.documentElement.scrollTop &&
				(left + width) > window.document.documentElement.scrollLeft
			);
		}
	},

	/**
	 * @function
	 * @description Appends the parameter 'format=ajax' to a given path
	 * @param {String} path the relative path
	 */
	ajaxUrl: function (path) {
		return this.appendParamToURL(path, 'format', 'ajax');
	},

	/**
	 * @function
	 * @description
	 * @param {String} url
	 */
	toAbsoluteUrl: function (url) {
		if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
			url = '/' + url;
		}
		return url;
	},
	/**
	 * @function
	 * @description Loads css dynamically from given urls
	 * @param {Array} urls Array of urls from which css will be dynamically loaded.
	 */
	loadDynamicCss: function (urls) {
		var i, len = urls.length;
		for (i = 0; i < len; i++) {
			this.loadedCssFiles.push(this.loadCssFile(urls[i]));
		}
	},

	/**
	 * @function
	 * @description Loads css file dynamically from given url
	 * @param {String} url The url from which css file will be dynamically loaded.
	 */
	loadCssFile: function (url) {
		return $('<link/>').appendTo($('head')).attr({
			type: 'text/css',
			rel: 'stylesheet'
		}).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
	},
	// array to keep track of the dynamically loaded CSS files
	loadedCssFiles: [],

	/**
	 * @function
	 * @description Removes all css files which were dynamically loaded
	 */
	clearDynamicCss: function () {
		var i = this.loadedCssFiles.length;
		while (0 > i--) {
			$(this.loadedCssFiles[i]).remove();
		}
		this.loadedCssFiles = [];
	},

	/**
	 * @function
	 * @description Extracts all parameters from a given query string into an object
	 * @param {String} qs The query string from which the parameters will be extracted
	 */
	getQueryStringParams: function (qs) {
		if (!qs || qs.length === 0) {
			return {};
		}
		var params = {},
			unescapedQS = decodeURIComponent(qs);
		// Use the String::replace method to iterate over each
		// name-value pair in the string.
		unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
			function ($0, $1, $2, $3) {
				params[$1] = $3;
			}
		);
		return params;
	},

	fillAddressFields: function (address, $form) {
		for (var field in address) {
			if (field === 'ID' || field === 'UUID' || field === 'key') {
				continue;
			}
			// if the key in address object ends with 'Code', remove that suffix
			// keys that ends with 'Code' are postalCode, stateCode and countryCode
			$form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field]);
			// update the state fields
			if (field === 'countryCode') {
				$form.find('[name$="country"]').trigger('change');
				// retrigger state selection after country has changed
				// this results in duplication of the state code, but is a necessary evil
				// for now because sometimes countryCode comes after stateCode
				$form.find('[name$="state"]').val(address.stateCode);
			}
		}
	},
	/**
	 * @function
	 * @description Updates the number of the remaining character
	 * based on the character limit in a text area
	 */
	limitCharacters: function () {
		$('form').find('textarea[data-character-limit]').each(function () {
			var characterLimit = $(this).data('character-limit');
			var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG,
				'<span class="char-used-count"> 0 </span>',
				'<span class="char-allowed-count">' + characterLimit + '</span>');

			//if window size is small then char-count should be after
			var containerPlacement = $(this).prev('div.char-count');
			var containerInsert = $('<div class="char-count"/>').insertBefore($(this));

			var charCountContainer = containerPlacement;
			if (charCountContainer.length === 0) {
				charCountContainer = containerInsert;
			}
			charCountContainer.html(charCountHtml);
			// trigger the keydown event so that any existing character data is calculated
			$(this).change();
		});
	},
	/**
	 * @function
	 * @description Binds the onclick-event to a delete button on a given container,
	 * which opens a confirmation box with a given message
	 * @param {String} container The name of element to which the function will be bind
	 * @param {String} message The message the will be shown upon a click
	 */
	setDeleteConfirmation: function (container, message) {
		$(container).on('click', '.delete', function () {
			return window.confirm(message);
		});
	},
	/**
	 * @function
	 * @description Scrolls a browser window to a given x point
	 * @param {String} The x coordinate
	 */
	scrollBrowser: function (xLocation) {
		$('html, body').animate({
			scrollTop: xLocation
		}, 500);
	},

	isMobile: function () {
		var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
		var idx = 0;
		var isMobile = false;
		var userAgent = (navigator.userAgent).toLowerCase();

		while (mobileAgentHash[idx] && !isMobile) {
			isMobile = (userAgent.indexOf(mobileAgentHash[idx]) >= 0);
			idx++;
		}
		return isMobile;
	},

	/**
	 * @function getCookieSelector
	 * @description Returns the cookie value
	 **/
	getCookieSelector: function (cookieName) {
		var regularExpression = '(?:(?:^|.*;\\s*)' + cookieName + '\\s*\\=\\s*([^;]*).*$)|^.*$';
		var regExp = new RegExp(regularExpression, '');

		return document.cookie.replace(regExp, '$1');
	},
	/**
	 * @function getCookieValue
	 * @description Returns the cookie value
	 **/
	getCookieValue: function (cookieName) {
		var regex = new RegExp(`(^| )${cookieName}=([^;]+)`)
      	var match = document.cookie.match(regex)
      if (match) {
        return match[2]
      }
	},

	/**
	 * @function setCookie
	 *
	 * @param {string} key - The cookie name
	 * @param {string} value - The cookie value
	 * @param {integer} minutes - The number of minutes to expire the cookie
	 **/
	setCookie: function (key, value, minutes) {
		var duration = '';

		if (minutes) {
			var date = new Date();

			date.setTime(date.getTime() + (minutes * 60 * 1000));

			duration = ' expires=' + date.toGMTString() + ';';
		}

		document.cookie = key + '=' + value + ';' + duration + ' path=/';
	},

	/**
	 * @function validateEmail
	 *
	 * @description Returns boolean
	 * @param {string} emailAddress - The email address
	 **/
	validateEmail: function (emailAddress) {
		var emailRegExp = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$');

		return emailRegExp.test(emailAddress);
	},

	/**
	 * @function validateMessage
	 *
	 * @description Returns boolean
	 * @param {string} message - The message
	 **/
	validateMessage: function (message) {
		var messageRegExp = /^[\w\.\,\!\?\;\:\(\)\'\" \n]*$/;

		return messageRegExp.test(message);
	},

	/**
	 * @function maximizeCheckoutSummary
	 *
	 * @description Maximizes/Expands the Order Checkout Summary
	 **/
	maximizeCheckoutSummary: function () {
		if (SitePreferences.IS_CHECKOUT_MAXIMIZED) {
			$('.accordion-navigation').addClass('is-active');
			$('.accordion-title').attr('aria-expanded', true);
			$('.accordion-title').attr('aria-selected', true);
			$('#panel11a').css('display', 'block');
		}
	},
	/**
	 * @function ieAnimation
	 *
	 * @description animation support for IE browser
	 **/
	ieAnimation: function () {
		$("html, body").animate({
			scrollTop: $('.header-wrapper').offset().top
		}, 300, 'linear', function () {});
	},
	/**
	 * @function scrollBanner
	 *
	 * @description Scroll top banner to bottom
	 **/
	scrollBanner: function () {
		var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		var amountoScrolled = $('.header-wrapper').offset().top - $(window).scrollTop();
		if (navigator.userAgent.match(/msie/i) || navigator.userAgent.match(/trident/i)) {
			window.requestAnimationFrame(util.ieAnimation);
		} else if (isSafari && navigator.userAgent.match(/iPad/i)) {
			$("html, body").animate({
				scrollTop: $('.header-wrapper').offset().top
			}, 500, 'linear', function () {});
		} else {
			window.scrollBy({
				top: amountoScrolled,
				left: 0,
				behavior: 'smooth'
			});
		}
	},
	scrollToError : function(scrollingArea,errorDistance,animationTime) {
		 try{
			scrollingArea.animate({
 				scrollTop:errorDistance.offset().top  - 150
 			},animationTime);
		 }
		 catch(error){
			 return;
		 }
		 
	},
	capitalizeFirstLetters: function(title) {
		return title.replace(/\w\S*/g, function(text) {
			return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
		});
	},
	isTouchScreen: function() {
		return ('ontouchstart' in window || 'ontouch' in window);
	},
	getFormattedCurrency: function(accessLocale, accessCurrency, price) {
		let formattedCurr = Intl.NumberFormat(accessLocale, {
		    style: "currency",
		    currency: accessCurrency,
		});
		return formattedCurr.format(price);
	},

	/**
	 * 
	 * @param {*} Use this function for adding three dots after any title  
	 * @param {*} desktopklength For desktop 
	 * @param {*} mobilelength for mobile
	 */

	paraEndWithThreeDots: function (element, desktopklength, mobilelength) {
		var elementName = $(element);
		var count = $(window).width() > 991 ? desktopklength : mobilelength;
		elementName.each(function () {
			var elementNameNameVal = $(this).html();
			var elementNameNameUpdated = elementNameNameVal.slice(0, count) + (elementNameNameVal.length > count ? "..." : "");
			$(this).html(elementNameNameUpdated);
		});
	},

	/**
	 * 
	 * @param {*} Equal Height Method
	 */
	equalHeight: function (element) {
		var maxHeight = 0;
		var elementSelector = $(element);
		elementSelector.each(function (index, ele) {
			var elementHeight = $(ele).outerHeight();
			if (elementHeight > maxHeight) {
				maxHeight = elementHeight;
			}
		});
		elementSelector.css({
			'min-height': maxHeight,
			'height': maxHeight,
		});
	},
	
	/**
	 * @function
	 * @description Highlights the partially or fully visible slides in a Slick carousel container.
	 *              Adds the 'truly-visible' class to those slides.
	 * @param {String|jQuery} $carousel - jQuery object or selector string for the Slick carousel container.
	 */
	getTrulyVisibleSlides: function ($carousel) {
		return new Promise((resolve) => {
			const $slides = $carousel.find('.slick-slide').not('.slick-cloned');
			const $images = $carousel.find('img');
			let previousVisibleIndexes = [];
			let stableCount = 0;

			function arraysEqual(array1, array2) {
				if (array1.length !== array2.length) return false;
				for (let i = 0; i < array1.length; i++) {
					if (array1[i] !== array2[i]) return false;
				}
				return true;
			}

			function checkVisibility() {
				const slickList = $carousel.find('.slick-list')[0];
				const listRect = slickList.getBoundingClientRect();
				const newlyVisible = [];

				$slides.each(function () {
					const rect = this.getBoundingClientRect();
					const isVisible = (
						rect.right > listRect.left &&
						rect.left < listRect.right
					);
					if (isVisible) {
						newlyVisible.push(this);
					}
				});

				const newIndexes = newlyVisible.map(slide => $(slide).data('slick-index')).sort();

				if (arraysEqual(newIndexes, previousVisibleIndexes)) {
					stableCount++;
					if (stableCount >= 2) {
						$slides.removeClass('truly-visible');
						$(newlyVisible).addClass('truly-visible');
						// Done, resolve promise
						resolve();
						return;
					}
				} else {
					stableCount = 0;
					previousVisibleIndexes = newIndexes;
				}
				requestAnimationFrame(checkVisibility);
			}

			// Image loading check
			const unloadedImages = $images.filter(function () {
				return !this.complete;
			});

			if (unloadedImages.length > 0) {
				let loadedCount = 0;
				unloadedImages.on('load error', function () {
					loadedCount++;
					if (loadedCount === unloadedImages.length) {
						requestAnimationFrame(checkVisibility);
					}
				});
			} else {
				// All images already loaded
				requestAnimationFrame(checkVisibility);
			}
		});
	}
};


util.ellipsisOnLongText = function(elementSelector) {
	elementSelector.each(function (index, element) {
		$(element).css('-webkit-box-orient', 'vertical');
	})
};

/**
 * debounce function to optimize performance by reducing the frequency of window.matchMedia checks during window resize events.
 * 
 * @param {Function} func - The function to debounce.
 * @param {number} wait - The number of milliseconds to delay.
 * @returns {Function} - Returns the new debounced function.
 */

util.debounce =  function(func, wait) {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
};

/**
 * Make all .compare-attributes-item in each .product-compare-attributes (ol) have the same height as the tallest li.
 * Run this after DOM ready and after any dynamic update.
 */
util.setCompareAttributesEqualHeight = function(parentSelector, childSelector) {
    var $columns = $(parentSelector);
    if ($columns.length === 0) return;

    // Reset heights
    $columns.find(childselector).css('height', '');

    // Find the max number of rows
    var maxRows = 0;
    $columns.each(function () {
        maxRows = Math.max(maxRows, $(this).find(childselector).length);
    });

    // For each row index, find the max height and set it for all columns
    for (var row = 0; row < maxRows; row++) {
        var maxHeight = 0;
        // Find max height for this row across all columns
        $columns.each(function () {
            var $item = $(this).find(childselector).eq(row);
            if ($item.length) {
                maxHeight = Math.max(maxHeight, $item.outerHeight());
            }
        });
        // Set this height for all columns at this row
        $columns.each(function () {
            var $item = $(this).find(childselector).eq(row);
            if ($item.length) {
                $item.css('height', maxHeight + 'px');
            }
        });
    }
};

/**
 * Utility to poll for a selector until it exists, then resolve with the element.
 * @param {string} selector - jQuery selector to wait for
 * @param {number} intervalMs - Polling interval in ms
 * @returns {Promise<JQuery>}
 */
util.waitForElement = function(selector, intervalMs = 500) {
    return new Promise((resolve) => {
        const interval = setInterval(() => {
            const $el = $(selector);
            if ($el.length) {
                clearInterval(interval);
                resolve($el);
            }
        }, intervalMs);
    });
};

util.bodyPositionFixed = function(id) {
	if (navigator.userAgent.match(/(iPhone|iPad)/)) {
		var windowScrollPosition = $(window).scrollTop();
		$('body').addClass('body-fixed');
		$('.' + id + ' .modal-close, .' + id + ' .modal-close-outer').off('click').on('click', function () {
			$('.' + id).remove();
			$('body').removeClass('body-fixed');
			$('html').removeClass('modal-open');
			$(window).scrollTop(windowScrollPosition);
		});
	}
};

util.validateMessage = function (message) {
    var messageRegExp = RegExp(SitePreferences.MESSAGE_REGEXP);

    return messageRegExp.test(message);
};


util.getCallingCountryCode = function(countryCode){
    	 
    // ISO Country Code and country calling codes mapping
    var callingCodesCountryMapping = {
        at:'+43',
        be:'+32',
        nl:'+31',
        lu:'+352',
        ie:'+353',
        es:'+34',
        bg:'+359',
        cy:'+357',
        cz:'+420',
        dk:'+45',
        ee:'+372',
        hr:'+385',
        fi:'+358',
        gr:'+30',
        hu:'+36',
        lv:'+371',
        lt:'+370',
        mt:'+356',
        pl:'+48',
        pt:'+351',
        ro:'+40',
        sk:'+421',
        si:'+386',
        se:'+46',
        de:'+49',
        fr:'+33',
        it:'+39',
        gb:'+44'
    };
		
	 return callingCodesCountryMapping[countryCode.toLowerCase()];
},

util.getCallingPhoneNumPrefix = function(countryCode){
    	 
    // ISO Country Code and country calling codes mapping
    var callingPhoneNumPrefixMapping = {
        at:'0',
        be:'0',
        nl:'0',
        ie:'0',
        bg:'0',
        hr:'0',
        fi:'0',
        lt:'8',
        ro:'0',
        sk:'0',
        si:'0',
        se:'0',
        de:'0',
        fr:'0',
        gb:'0'
    };
	
		
	 return callingPhoneNumPrefixMapping[countryCode.toLowerCase()];
},
 
/*
 * This function pre-populates the calling country code in
 * mobile phone number field on shipping page.
 */
util.prePopulateCallingCountryCode = function(countryCode) {
    if(countryCode){
        if(($('input[name$="_areaCode"]').length > 0)){
            var callingCountryCode = this.getCallingCountryCode(countryCode);
            $('input[name$="_areaCode"]').val(callingCountryCode);
        }
    }
}
/**
  * populate areacode in required element
  */
util.prePopulateCallingCountryCodeEle = function(countryCode,el) {	 
	 var shippingBillAdd = $(el).parents('.select-billing-address');
	 var shippingShipAdd = $(el).parents('.shipping-address-section');
	 var editModalBillAdd = $(el).parents('.edit-add-address');	 
	 if(shippingBillAdd.length > 0 && countryCode &&  shippingBillAdd.find('input[name$="_areaCode"]').length > 0){		
        var callingCountryCode = this.getCallingCountryCode(countryCode);
        shippingBillAdd.find('input[name$="_areaCode"]').val(callingCountryCode);
    }else if (editModalBillAdd.length > 0 && countryCode &&  editModalBillAdd.find('input[name$="_areaCode"]').length > 0){		
        var callingCountryCode = this.getCallingCountryCode(countryCode);
        editModalBillAdd.find('input[name$="_areaCode"]').val(callingCountryCode);
    }else if(shippingShipAdd.length > 0 && countryCode &&  shippingShipAdd.find('input[name$="_areaCode"]').length > 0){		
        var callingCountryCode = this.getCallingCountryCode(countryCode);
        shippingShipAdd.find('input[name$="_areaCode"]').val(callingCountryCode);
    }

}
 
/**
	 * @function
	 * @description Updates the number of the remaining character
	 * based on the character limit in a text area
	 */
util.limitCharacters = function () {
    $('form').find('[data-character-limit]').each(function () {
        var characterLimit = $(this).data('character-limit');
        var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG,
            '<span class="char-used-count"> 0 </span>',
            '<span class="char-allowed-count">' + '/' + characterLimit + '</span>');
        if ($(this).hasClass('returncomments')) {
            charCountHtml = String.format(Resources.CHAR_LIMIT_RETURN_MSG,
                '<span class="char-remain-count">' + characterLimit +  '</span>');
        }
        //if window size is small then char-count should be after
        var containerPlacement = $(this).prev('div.char-count');
        var containerInsert = $('<div class="char-count"/>').insertBefore($(this));
		
        var charCountContainer = containerPlacement;
        if (charCountContainer.length === 0) {
            charCountContainer = containerInsert;
        }
        charCountContainer.html(charCountHtml);
        // trigger the keydown event so that any existing character data is calculated
        $(this).change();
    });
    $('form').find('div.char-count').each(function () {
        $(this).contents().filter(function () {
            return this.nodeType === Node.TEXT_NODE;
        }).remove();
        if ($(this).is(':empty')) {
            $(this).remove();
        }
    });
}
 
/**
  * CSRF update for post method ajax
  */
util.updateWithCsrfInputAjax = function () {
 	var csrf_token = $('meta[name="csrf-token"]').attr('content');	
 	
 	$.ajaxPrefilter(function(options, originalOptions, jqXHR){
 		
 	   if (options.type.toLowerCase() === 'post') {
 	        // initialize `data` to empty string if it does not exist
 	        options.data = options.data || '';
 	        // add _token entry
 	        var csrf_key = Constants.CSRF_TOKEN_NAME+'=';
 	        if(options.data.indexOf(csrf_key) === -1 && options.url.indexOf('Adyen-PaymentFromComponent') == -1){ //if request doesnt contain csrf_token then add
 	        // add leading ampersand if `data` is non-empty
 	 	        options.data += options.data?'&':'';
 	        	options.data += csrf_key + csrf_token;
 	        }
 	    }
 	});
}

util.bindGlobalEvents = function () {
	 //Redirect user to the CSRF Failed page if CSRF error occurred.
	 $(document).bind('ajaxComplete', function(jqXHRObj, status){
		 if (status && status.responseJSON && status.responseJSON.isCSRFError) {
			 window.location = Urls.csrffailed;
			 localStorage.removeItem('storeDetailsSection');
			 localStorage.removeItem('selectedStoreData');
			 localStorage.removeItem('royalMail-edit');
			 localStorage.removeItem('storedAddressData');
		 }
	 });
};
 
util.delay =  (function(){
	  var timer = 0;
	  return function(callback, ms){
	  clearTimeout(timer);
	  timer = setTimeout(callback, ms);
	 };
})();
 
util.parseQueryString = function (url) {
    var urlParams = {};
    url.replace(
        new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
        function ($0, $1, $2, $3) {
            if (typeof $3 != 'undefined') {
                urlParams[$1] = $3;
            }
        }
    );
    return urlParams;
};
	
util.isMobile = function () {
    return $(window).width() <= 640;
};

util.generalExtension = function () {
    var s = arguments[0];
    var i, len = arguments.length - 1;

    for (i = 0; i < len; i++) {
        var reg = new RegExp('\\{' + i + '\\}', 'gm');

        s = s.replace(reg, arguments[i + 1]);
    }

    return s;
};

/*
 * This function pre-populates the calling country code in
 * mobile phone number field on shipping page.
 */
util.getFormattedPhoneNumber = function(customFoneNumber,selectedCountryCode) {
    if(customFoneNumber != undefined && selectedCountryCode != undefined){
        var countryCodePrefix = this.getCallingCountryCode(selectedCountryCode);
        var phoneNumPrefix = this.getCallingPhoneNumPrefix(selectedCountryCode);
        if(phoneNumPrefix && (customFoneNumber.charAt(0) == phoneNumPrefix)){
            customFoneNumber = countryCodePrefix+''+customFoneNumber.slice(1);
        } else {
            customFoneNumber = countryCodePrefix+''+customFoneNumber;
        }
        return customFoneNumber;
    }
    return '';
};

util.getPhoneNumWithCode = function() {
    if($('#dwfrm_billing_billingAddress_addressFields_areaCode').length === 0 && $('#dwfrm_billing_billingAddress_addressFields_phoneNumber').length === 0) { 
        return; 
    }

    $('#modal-custom-placeholder, .checkout-shipping-content, .account-side-panel').on('focusout','input[class~="phonenumber"]', function() {
        var customPhoneNumber = $('#dwfrm_billing_billingAddress_addressFields_phoneNumber').val();
        var selectedCountryCode = $('#dwfrm_billing_billingAddress_addressFields_country').val();
        if(customPhoneNumber !== null && selectedCountryCode !== null){
            var custFoneNumb = util.getFormattedPhoneNumber(customPhoneNumber,selectedCountryCode);
            $('#dwfrm_billing_billingAddress_addressFields_phone').val(custFoneNumb);		
        }
    });
};

util.ellipsisOnLongText = function(elementSelector) {
    elementSelector.each(function (index, element) {
        $(element).css('-webkit-box-orient', 'vertical');
    })
};

// Function to remove area code and symbol
util.removeAreaCode =  function(phone, areaCode) {
    // Convert both to strings
    phone = phone.toString().trim();
    areaCode = areaCode.toString().trim();

    // Remove '+' if present in the phone
    phone = phone.startsWith("+") ? phone.slice(1) : phone;
    areaCode = areaCode.startsWith("+") ? areaCode.slice(1) : areaCode;

    // Check if the area code is at the start using indexOf
    if (phone.indexOf(areaCode) === 0) {
        return phone.slice(areaCode.length); // Remove the area code
    }

    // Return original phone if no match
    return phone;
}
/**
 * debounce function to optimize performance by reducing the frequency of window.matchMedia/settimeout checks during events.
 * 
 * @param {Function} func - The function to debounce.
 * @param {number} wait - The number of milliseconds to delay.
 * @returns {Function} - Returns the new debounced function.
 */
util.debounce =  function(func, wait) {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

/**
 * Toggles the password visibility icon in the login page.
 * @function
 * @description When the icon is clicked, the password input field's type is toggled between "password" and "text", effectively showing/hiding the password.
 */
util.passwordShowHideToggle = function( element ) {
    // Bind the event on the container to support dynamic elements
    $(element).on('click', '.user-pass .icon', function(e) {
      e.preventDefault();
      var $icon = $(this);
      // Locate the associated input within the same container
      var $input = $icon.closest('.user-pass').find('input');
      // Determine if the input is currently of type "password" and toggle it
      var isPassword = $input.attr('type') === 'password';
      $input.attr('type', isPassword ? 'text' : 'password');
      // Toggle the icon classes
      $icon.toggleClass('icon-eye icon-eye-slash');
    });
  };

/**
 * @function
 * @description This function is used to validate the password input on the login/Account page.
 *              It checks the length of the password, whether it contains a number, an alphabet, and a special character.
 *              If any one of the condition fails, the respective icon will be changed to a 'close' icon.
 *              If all conditions are met, the respective icon will be changed to a 'checkmark' icon.
 */
util.validatePasswordInputs = function( element ) {
    let password = $(element).find('input').val();
    let all_pass = true;
  
    const number = password.match(/[0-9]/); // Number
    const alpha = password.match(/[a-zA-Z]/); // Alphabet
    const speCharacter = password.match(/^(?=.*[_\W]).+$/); // Special character 
    const $password_length = $('#password_length');
    const $password_number = $('#password_number');
    const $password_special = $('#password_special');
    const $password_rules = $('#password_rules');

    if (!$password_length.hasClass('valid') || !$password_number.hasClass('valid') || !$password_special.hasClass('valid')) {
        $password_rules.show();
      } else {
        $password_rules.hide();
      }
  
    if (password.length < 8) {
      $password_length.removeClass('valid');
      $password_length.find('.icon').removeClass('checkmark-valid').addClass('icon-close');
        all_pass = false;
    } else {
      $password_length.addClass('valid');
      $password_length.find('.icon').removeClass('icon-close').addClass('checkmark-valid');
    }
  
    if (number) {
      $password_number.addClass('valid');
      $password_number.find('.icon').removeClass('icon-close').addClass('checkmark-valid');
    } else {
      $password_number.removeClass('valid');
      $password_number.find('.icon').removeClass('checkmark-valid').addClass('icon-close');
        all_pass = false;
    }
  
    if (speCharacter) {
      $password_special.addClass('valid');
      $password_special.find('.icon').removeClass('icon-close').addClass('checkmark-valid');
    } else {
      $password_special.removeClass('valid');
      $password_special.find('.icon').removeClass('checkmark-valid').addClass('icon-close');
        all_pass = false;
    }
  };


/**
 * Checks if the session has expired by attempting to parse the given response.
 * If the JSON is valid and indicates an expired session, the user is redirected to the login page.
 *
 * @param {string|object} response - The JSON string or object representing session status information.
 * @returns {boolean} - Returns true if the session is expired (and redirection occurs), otherwise false.
 */
util.checkSessionTimeout = function(response) {
    // Check if the response is a string or an object
    // If response is undefined, null, or falsy, do not proceed
    if (typeof response === 'undefined' || response === null || !response) {
        return false;
    }

    const $sidePanel = $('#account-side-panel');
    const $addListWrapper = $('.address-list-wrapper');
    const $modalCustomPlaceholder = $('#modal-custom-placeholder');

    // Cache values at the top
    const showLoginUrl = Urls.showLogin;

    // Check for modal presence first
    $modalCustomPlaceholder.html(response).hide();
    const hasReturningCustomers = $modalCustomPlaceholder.find('.returning-customers').length > 0;

    if (hasReturningCustomers) {
        handleSessionExpired();
        window.location.href = showLoginUrl;
        return true;
    }

    // Check for side panel presence
    function handleSessionExpired() {
        $sidePanel.find('.panel-body').remove();
        $addListWrapper.remove();
    }

    let data;
    let isSessionExpired = false;

    try {
        if (typeof response === 'object') {
            data = response;
        } else if (typeof response === 'string') {
            data = JSON.parse(response);
        } else {
            return false;
        }
        if (data.isSessionExpired === true) {
            isSessionExpired = true;
        }
    } catch (e) {
        // If parsing fails, response is not valid JSON
        return false;
    }
    
    if (isSessionExpired) {
        handleSessionExpired();
        window.location.href = showLoginUrl;
        return true;
    }

    return false;
};

/**
 * Make all .compare-attributes-item in each .product-compare-attributes (ol) have the same height as the tallest li.
 * Run this after DOM ready and after any dynamic update.
 */
util.setCompareAttributesEqualHeight = function(parentselector, childselector) {
    var $columns = $(parentselector);
    if ($columns.length === 0) return;

    // Reset heights
    $columns.find(childselector).css('height', '');

    // Find the max number of rows
    var maxRows = 0;
    $columns.each(function () {
        maxRows = Math.max(maxRows, $(this).find(childselector).length);
    });

    // For each row index, find the max height and set it for all columns
    for (var row = 0; row < maxRows; row++) {
        var maxHeight = 0;
        // Find max height for this row across all columns
        $columns.each(function () {
            var $item = $(this).find(childselector).eq(row);
            if ($item.length) {
                maxHeight = Math.max(maxHeight, $item.outerHeight());
            }
        });
        // Set this height for all columns at this row
        $columns.each(function () {
            var $item = $(this).find(childselector).eq(row);
            if ($item.length) {
                $item.css('height', maxHeight + 'px');
            }
        });
    }
};

util.bodyPositionFixed = function(id) {
	if (navigator.userAgent.match(/(iPhone|iPad)/)) {
		var windowScrollPosition = $(window).scrollTop();
		$('body').addClass('body-fixed');
		$('.' + id + ' .modal-close, .' + id + ' .modal-close-outer').off('click').on('click', function () {
			$('.' + id).remove();
			$('body').removeClass('body-fixed');
			$('html').removeClass('modal-open');
			$(window).scrollTop(windowScrollPosition);
		});
	}
};


export default util;
